<template>
<div id="WECHAT_QRCODE">

</div>
</template>

<script>
import * as ww from '@wecom/jssdk';
export default {
    name: "qy-wecaht-qrcode",
    data(){
        return {
            obj: null
        }
    },
    methods:{
        loadWeChat() {
            const return_url =this.$organization.signin_url;
            let state = "wx";
            if (this.$route.query._t) {
                state = "wx_" + encodeURIComponent(this.$route.query._t);
            }
            const params = {
                    login_type: 'CorpApp',
                    appid: this.$organization.wechat_appid,
                    agentid: this.$organization.wechat_agentid,
                    redirect_uri: return_url,
                    state: state,
                    redirect_type: 'top',
                    panel_size: 'small',
                };

            this.obj = ww.createWWLoginPanel({
                el: '#WECHAT_QRCODE',
                params: params
            })
        }
    },
    mounted(){
        this.loadWeChat();
    },
    beforeDestroy(){
        if (this.obj) this.obj.unmount();
    }
}

</script>

<style scoped>

</style>